<div cdkDropList (cdkDropListDropped)="drop($event, $event.item.data.id)">
  <eas-editor-booking-item-option *ngFor="let itemOption of itemOptions; let itemOptionIndex = index" [cdkDragData]="itemOption" cdkDrag
    [itemOption]="itemOption"
    [itemOptionIndex]="itemOptionIndex"
    [levelLines]="levelLinesList[itemOptionIndex]"
  >
  </eas-editor-booking-item-option>
</div>
